var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-stepper-content',_vm._b({},'v-stepper-content',_vm.$props,false),[(_vm.step === _vm.currentStep)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }